import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Rx";
import 'rxjs/add/operator/map';

import { Observation } from "../../models/observation.interface";
import { Api } from "../util/api";

@Injectable()
export class ObservationsService {
  private endpoint: string = 'observations';

  constructor(private api: Api) {
  }

  archiveObservation(observation: Observation): Observable<Observation> {
    observation.observationState = 'ARCHIVED';
    return this.updateObservation(observation).map(
      (observation) => this.api.handleSuccess(observation, 'Archivage réussi !')
    );
  }

  getObservations(observationState: string): Observable<Observation[]> {
    return this.api.get(`${this.endpoint}/${observationState}`);
  }

  updateObservation(observation: Observation): Observable<Observation> {
    return this.api.put(`${this.endpoint}/${observation.id}`, observation);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/observations-service.ts